import * as z from "zod";

export const onboardStripeConnectedAccount = {
  name: "onboardStripeConnectedAccount" as const,
  input: z.object({ refreshUrl: z.url(), returnUrl: z.url() }),
  output: z.object({ url: z.url() }),
};
